import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import store from '../../store';
import Modal from 'react-modal';  
import Modal_Costos from './modal_costos';  
import Slide from '../Globals/Slide/slide'

//Se obtiene conexion con las funcionalidades de firebase
const database = firebase.database();



const customStyles = {
  content : {
    top                   : '85%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '500px'
	
  }
};

class Costos extends Component {
    
    constructor(){
        super();
        this.state={
            Costos:[],
            Codigo:'',
            Descripcion:'',
            Responsable:'',
            Area:'',
            keyRow:'',
            template:false,
            empresaUID:''
            
        };
        this.updateRow=this.updateRow.bind(this);
        this.ocultarMenu=this.ocultarMenu.bind(this);
        this.costosRef = database.ref().child('CentroCosto');

        this.AlertaContenido = ({
            id,
            classNames,
            styles,
            message,
            customFields,
            handleClose,
          }) => {
          const handleConfirm = () => {
              
              this.updateRow();		
              Alert.close(id);
              this.setState({
                  template:false
              })
          }
              return (
              <div className={classNames} id={id} style={styles}>
                <div className='s-alert-box-inner'>
                      {message}
                </div>
                <br/>
                <br/>
                <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
                <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
                <span className='s-alert-close' onClick={handleClose}></span>
              </div>
              );
          }

        
        
    }

    ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}

    

    handleClickAlerta=(event)=>{
        this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
        event.preventDefault();
    }

    componentWillMount=()=>{
        Modal.setAppElement('body');
        let uid = firebase.auth().currentUser.uid;
        this.setState({empresaUID:uid})
    }

    componentDidMount=()=>{
        this.costosRef.on('value', this.gotData, this.errData);
    }

    //Llenar el arreglo que se utiliza la tabla
    gotData = (data) => {
        let Datos = [];
        if(data.val()!==null){
        const Base = data.val();
        const keys = Object.keys(Base);
        for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            if(Base[k].empresa ===this.state.empresaUID)
            {
                Datos.push({
                    key:k,
                    codigo:Base[k].codigo,
                    descripcion:Base[k].descripcion,
                    responsable:Base[k].responsable,
                    area:Base[k].area
                }) 
            }                
        }
        this.setState({Costos: Datos});  
    }
    }
    errDataBases = (err) => {
        console.log(err);
    }


    updateRow=()=>{
        let nodoHijo=this.keyRow.value;
        
        this.costosRef.child(nodoHijo).update({
        codigo:this.Codigo.value,
        descripcion:this.Descripcion.value,
        responsable:this.Responsable.value,
        area:this.Area.value,
        empresa:this.state.empresaUID
        });
        Alert.success('Datos actualizados correctamente', {
            effect: 'genie',
            position: 'bottom-right',
            timeout:2000
    });
    
    this.toggleModal();
    }
    //Genera el boton de editar de la tabla
    imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Modificar</button>;
	}

    //Se setean los valores de las row a las variables para que se llenen en el modal
    handleClick = (rowKey) => {
        this.setState({
            keyRow:rowKey.key,
            Codigo:rowKey.codigo,
            Descripcion:rowKey.descripcion,
            Responsable:rowKey.responsable,
            Area:rowKey.area
           
           });
           
       
           this.toggleModal();
    }

    //verifica que el modal este abierto o no
    
    toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,			
		})		
		
		
    }
   
    

    render() {
        return (
            <div onClick={this.ocultarMenu}> 
            <br/>
			<div className="Vehiculos container">      
           
                <div className="costos container" >
                <h1>Costos</h1>      
               
                <Modal_Costos/>

                {this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}

                <BootstrapTable data={ this.state.Costos }
                    ref='table'			 
                    pagination={ true }
                    search={ true }
                    hover
                    >
                    <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >key</TableHeaderColumn>
                    <TableHeaderColumn dataField='codigo' dataSort={true}>Costos</TableHeaderColumn>
                    <TableHeaderColumn dataField='descripcion' dataSort={true}>Descripcion</TableHeaderColumn>
                    <TableHeaderColumn dataField='responsable'>Responsable</TableHeaderColumn>
                    <TableHeaderColumn dataField='area' >Area</TableHeaderColumn>
                    <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
                </BootstrapTable>

                <Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
                
                <form method="POST" action="" onSubmit={this.handleClickAlerta}>
                    
                    <h3>Modificar Centro de costo</h3>
                    <hr/>
                    <input type="hidden" ref={input => {this.keyRow=input;}} value={this.state.keyRow}/>
                    <div className="form-group">
                        <label htmlFor="modelo" >Codigo:</label>
                        <input type="text" className="form-control" name="modelo" 
                            ref={input => {this.Codigo=input;}}
                            required autocomplete="off"
                            placeholder="Modelo"
                            defaultValue={this.state.Codigo}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modelo" >Descripción:</label>
                        <input type="text" className="form-control" name="modelo" 
                            ref={input => {this.Descripcion=input;}}
                            required autocomplete="off"
                            placeholder="Modelo"
                            defaultValue={this.state.Descripcion}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modelo" >Rsponsable:</label>
                        <input type="text" className="form-control" name="modelo" 
                            ref={input => {this.Responsable=input;}}
                            required autocomplete="off"
                            placeholder="Modelo"
                            defaultValue={this.state.Responsable}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="modelo" >Area:</label>
                        <input type="text" className="form-control" name="modelo" 
                            ref={input => {this.Area=input;}}
                            required autocomplete="off"
                            placeholder="Modelo"
                            defaultValue={this.state.Area}
                        />
                    </div>
                    <button className="btn btn-primary buttons" type="submit" >Guardar</button>
                </form>
                        
                </Modal>

                </div>
            </div>
            </div>
        );
    }
}


export default Costos;


// WEBPACK FOOTER //
// ./src/Components/Costos/Costos.jsx